export default __webpack_public_path__ + "static/media/shield-check.b54b25d0.svg";